<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import Markdown from 'vue3-markdown-it'
import { formatDate } from '@utils/date'

const route = useRoute()
const loading = ref(false)
const article = ref({})
const requestArticle = ref(null)
const slug = computed(() => route.params.slug)

function cancelArticle() {
	if (requestArticle.value) requestArticle.value.cancel()
}
function getArticle() {
	loading.value = true
	article.value = {}
	cancelArticle()
	let axiosSource = axios.CancelToken.source()
	requestArticle.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/news/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			article.value = a.data
		})
		.catch((e) => {})
}
getArticle()

watch(slug, async () => {
	getArticle()
})
</script>

<template>
	<section class="container flex justify-center">
		<!-- Breadcrumb -->
		<div class="flex flex-col gap-8 overflow-hidden md:max-w-[50%]">
			<div class="flex items-center justify-start gap-4 break-words font-body text-body-xs font-medium uppercase text-text-base">
				<span>blog</span>
				<i class="fas fa-chevron-right text-[10px] text-text-muted/50"></i>
				<span>article</span>
			</div>

			<svg xmlns="http://www.w3.org/2000/svg" width="1344" height="2" viewBox="0 0 1344 2" fill="none">
				<path d="M0 1H1344" stroke="white" stroke-opacity="0.2" stroke-width="1.5" stroke-dasharray="2 6" />
			</svg>

			<!-- Title -->
			<h1 class="break-words font-heading text-h2 font-medium uppercase text-sf-purple-base">
				{{ article?.title }}
			</h1>

			<!-- Meta Info -->
			<div class="flex items-center justify-start gap-6 font-body text-body-xs font-medium uppercase">
				<div class="flex h-8 items-center justify-center gap-3 break-words rounded-small border-2 border-solid border-sf-purple-base px-5">
					<span>{{ article?.category?.name }}</span>
				</div>
				<div class="flex items-center justify-center gap-2">
					<div class="flex items-center justify-start gap-3">
						<div class="h-1.5 w-1.5 bg-purple-300"></div>
						<time>{{ formatDate(article?.published_at) }}</time>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="container flex justify-center">
		<img class="w-full max-w-[1000px] rounded-[12px] border border-sf-purple-base" :src="article?.image" alt="article image" />
	</section>
	<section class="container md:max-w-[800px]">
		<Markdown class="markdown" :source="article?.body" />
	</section>

	<SwiperSection :articles="news?.filtered" title="other articles" />
</template>

<style scoped></style>
